import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { FiatCurrency } from '@quickbit/qb-design-system';

export interface Pagination {
  page: number;
  size: number;
}

export interface Refund {
  refundAmount: number;
  createdAt: Date;
  orderId: string;
  currency: string;
}

export interface MerchantRefundsFilters {
  createdFrom: Date | null;
  createdTo: Date | null;
  merchantIds: string[] | null;
}

export interface RefundsSortOptions {
  field: 'ORDER_ID' | 'CREATED_AT' | 'REFUND_AMOUNT';
  ascending: boolean;
}

interface MerchantTotalRefundsAggregatedData {
  refundCount: number;
  totalRefundAmount: number;
  currency: FiatCurrency;
}

interface MerchantRefundsResponse {
  refunds: Refund[];
  aggregatedData: MerchantTotalRefundsAggregatedData[];
}

export const searchRefunds = async ({
  pagination,
  filters,
  sortOptions,
}: {
  pagination?: Pagination;
  filters?: MerchantRefundsFilters;
  sortOptions?: RefundsSortOptions;
}) => {
  const convertedFilters = filters && {
    ...filters,
    createdFrom: filters.createdFrom ? filters.createdFrom.toISOString() : null,
    createdTo: filters.createdTo ? filters.createdTo.toISOString() : null,
  };
  const data = await fetchAPI<MerchantRefundsResponse>(`v1/refunds:search`, {
    method: 'POST',
    body: {
      pagination,
      filters: convertedFilters,
      sortOptions,
    },
  });

  return {
    ...data,
    refunds: data.refunds.map(({ createdAt, ...rest }) => ({
      createdAt: new Date(createdAt),
      ...rest,
    })),
  };
};
